import { get, post } from '../../../services/request';

export const getLiveAvailableShiftsWithPagination = async (payload) => {
    try {
        const response = await post('CapacityVsDemand/GetEncoreLiveAvailableShiftsWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchLegendTableData = () => {
    return get('CapacityVsDemand/GetCapsVsDemandLatestSimulatorLegend', {
    })
};

export const fetchPriorityGroupingLegend = () => {
    return get('Common/GetPriorityGroupingLegend', {});
};

export const fetchRadRequestType = () => {
    return get('RadRequest/GetRadRequestType', {});
};

export const fetchScheduleRecurrence = () => {
    return get('RadRequest/GetScheduleRecurrence', {});
};

export const saveRadRequest = async (payload) => {
    try {
        const response = await post('RadRequest/SaveRadRequest', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchLiveAvailableShiftsFilters = (reportId) =>
    get(`CapacityVsDemand/GetEncoreCapsVsDemandFilterDDList?ReportId=${reportId}`);

export const fetchLiveAvailableShiftsWorklists = (groupId) =>
    get(`WorklistGroup/GetAvailableWorklistDropDown?worklistGroupId=${groupId || 0}`);

export const saveLiveAvailableShiftsFilters = async (payload) => {
    return post('CapacityVsDemand/SaveLiveAvailableShiftsFilters', payload);
};